export default {"src":"/_next/static/media/search.f515d9ea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};